import { useState } from 'react';

import { useGetDepositsQuery } from '@epi-api/deposits/depositsApi';
import { BalanceCorrectionDate } from '@epi-models/pages/Reports';
import { getEndOfDay, getStartOfDay } from '@epi-helpers/dateHelper';

export const useDeposits = () => {
  const [page, setPage] = useState(1);
  const [showCalendar, setShowCalendar] = useState(false);
  const [timePeriodType, setTimePeriodType] = useState<string>();
  const [from, setFrom] = useState<BalanceCorrectionDate>(null);
  const [to, setTo] = useState<BalanceCorrectionDate>(null);

  const formattedFrom = from ? getStartOfDay(new Date(from)).toISOString() : '';
  const formattedTo = to ? getEndOfDay(new Date(to)).toISOString() : '';

  const { data, isLoading, isError } = useGetDepositsQuery({
    page,
    from: formattedFrom,
    to: formattedTo,
    abortController: null
  });

  const handleChangePage = (newPage: number) => {
    setPage(newPage);
  };

  const deposits = data?.items ?? [];
  const totalPages = data?.totalPages ?? 0;

  return {
    deposits,
    page,
    totalPages,
    isLoading,
    isError,
    showCalendar,
    setShowCalendar,
    timePeriodType,
    handleChangePage,
    from,
    to,
    setFrom,
    setTo,
    setPage,
    setTimePeriodType
  };
};
